import { render, staticRenderFns } from "./06.vue?vue&type=template&id=7d1ebb10&scoped=true&"
import script from "./06.vue?vue&type=script&lang=js&"
export * from "./06.vue?vue&type=script&lang=js&"
import style0 from "./06.vue?vue&type=style&index=0&id=7d1ebb10&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d1ebb10",
  null
  
)

export default component.exports